import { useState } from "react";
import CRM_API from "../../api/crmApi";

export default function CrmCreateUser() {
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("counsellor");
  const [showPassword, setShowPassword] = useState(false);

  const createUser = async () => {
    try {
      await CRM_API.post("/auth/register", {
        full_name: fullName,
        mobile,
        password,
        role,
      });
      alert("User Created Successfully");
      setFullName("");
      setMobile("");
      setPassword("");
    } catch (err) {
      alert("User Creation Failed");
    }
  };

  return (
    <div>
      <h4 className="fw-bold mb-4">Create CRM User</h4>

      <div className="card shadow-sm" style={{ maxWidth: "420px" }}>
        <div className="card-body">
          <div className="mb-3">
            <label className="form-label">Full Name</label>
            <input
              placeholder="Full Name"
              className="form-control"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Mobile</label>
            <input
              placeholder="Mobile"
              className="form-control"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`bi bi-eye${showPassword ? "-slash" : ""}`}></i>
              </button>
            </div>
          </div>
          <div className="mb-4">
            <label className="form-label">Role</label>
            <select
              className="form-select"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="admin">Admin</option>
              <option value="counsellor">Counsellor</option>
            </select>
          </div>

          <button onClick={createUser} className="btn btn-success w-100">
            <i className="bi bi-person-plus me-1"></i> Create User
          </button>
        </div>
      </div>
    </div>
  );
}
